import React from "react";
import { useParams, Link } from "react-router-dom";

const POLICIES = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "BananaX is committed to the highest standards of customer discretion. We collect only the information necessary to fulfill your order and provide concierge service.",
      "Personal data — name, email, shipping address, payment details — is encrypted in transit and at rest, never sold, and shared only with logistics partners required to deliver your order.",
      "Marketing communications are opt-in only. You may unsubscribe at any time. Subscription billing details are stored with PCI-DSS-compliant payment processors; we do not retain card numbers on our servers.",
      "For data access, correction or deletion requests, please write to contact@mediproexpress.com. We respond within 7 business days.",
    ],
  },
  shipping: {
    title: "Shipping Policy",
    body: [
      "Every BananaX order is dispatched in plain, unmarked outer packaging via a discreet courier. The sender is listed as 'BX Distribution' on the airway bill.",
      "Standard delivery within India is 2–4 business days for metros, 4–7 days for other regions. Express delivery (1–2 days) available on checkout.",
      "Subscription boxes ship on the 1st of every month; you receive a quiet email confirmation only, never an SMS.",
      "International shipping available to select countries. Customs and duties may apply at destination.",
      "Lost-in-transit or damaged-on-arrival packages are replaced at no charge — please write to contact@mediproexpress.com within 7 days of expected delivery.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "BananaX products are intended exclusively for adults aged 18 years and above. By placing an order, you confirm that you meet this age requirement.",
      "All products are tested to ISO 4074 and EN ISO 23409 standards. While engineered for maximum reliability, no condom is 100% effective against pregnancy or sexually transmitted infections.",
      "Subscription orders auto-renew on the same calendar date each month / quarter. You may pause, skip or cancel from your dashboard at any time prior to the renewal date.",
      "Refunds are available for unopened, unused product within 14 days of delivery. Opened or used products cannot be refunded for hygiene reasons.",
      "These terms are governed by the laws of India. Any disputes will be resolved through arbitration in New Delhi.",
    ],
  },
};

export default function Policy() {
  const { slug } = useParams();
  const policy = POLICIES[slug];

  if (!policy) {
    return (
      <div className="pt-40 text-center min-h-screen">
        <p className="text-mist">Policy not found.</p>
        <Link to="/" className="text-gold mt-4 inline-block">Return home</Link>
      </div>
    );
  }

  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid={`policy-${slug}-page`}>
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="label-eyebrow mb-4">Policy</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight leading-none mb-12">
          {policy.title}
        </h1>
        <div className="space-y-6">
          {policy.body.map((p, i) => (
            <p key={i} className="text-bone/90 font-light leading-relaxed text-lg">
              {p}
            </p>
          ))}
        </div>
        <p className="label-eyebrow text-mist mt-16">Last updated: February 2026</p>
      </div>
    </div>
  );
}
